import React, { FC, useState, useEffect } from 'react';
import { Modal, Spin } from 'antd';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import '../mediaPreviewModal.scss';

interface FullScreenVideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

export const FullScreenVideoModal: FC<FullScreenVideoModalProps> = ({
  isOpen,
  onClose,
  videoUrl,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadedUrl, setLoadedUrl] = useState('');

  useEffect(() => {
    if (isOpen && videoUrl !== loadedUrl) {
      setIsLoading(true);
    }
  }, [isOpen, videoUrl, loadedUrl]);

  const antIcon = <LoadingOutlined style={{ fontSize: 48, color: '#ffa100' }} spin />;

  return (
    <Modal
      className="media-preview-modal"
      rootClassName="media-preview-modal-root"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={760}
      style={{ maxWidth: '90vw', padding: 0 }}
      destroyOnHidden
      closable={true}
      closeIcon={
        <span
          style={{
            color: '#fff',
            fontSize: '15px',
            backgroundColor: 'rgba(15, 23, 42, 0.9)',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
          }}
        >
          <CloseOutlined />
        </span>
      }
      styles={{
        mask: {
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(20, 22, 28, 0.72)',
        },
        body: {
          padding: 0,
          background: '#000',
          borderRadius: '10px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '300px',
        },
      }}
    >
      {videoUrl && (
        <div
          style={{
            width: '100%',
            minHeight: isLoading ? '300px' : 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            borderRadius: '10px',
            overflow: 'hidden',
            background: '#000',
          }}
        >
          {isLoading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                background: '#1a1f2e',
              }}
            >
              <Spin indicator={antIcon} />
            </div>
          )}
          <video
            src={videoUrl}
            controls
            autoPlay
            playsInline
            onLoadedData={() => {
              setIsLoading(false);
              setLoadedUrl(videoUrl);
            }}
            onCanPlay={() => {
              setIsLoading(false);
              setLoadedUrl(videoUrl);
            }}
            style={{
              width: '100%',
              maxHeight: '75vh',
              display: 'block',
              objectFit: 'contain',
              borderRadius: '10px',
              opacity: isLoading ? 0 : 1,
              transition: 'opacity 0.2s ease',
            }}
          />
        </div>
      )}
    </Modal>
  );
};
